import React, { useEffect, useRef, useState } from "react";
import "./DosaChutneyContact.scss"
import heroBackground from "../../assets/images/galleryBg.png"
import border from "../../assets/images/border.png"
import InputComponent from "../../components/InputComponents/InputComponent";
import TextAreaComponent from "../../components/InputComponents/TextAreaComponent";
import { contactEnquiry } from "../../../../../utilities/apiRequests/witmegRetailPaxServerRequests";
import { useSelector } from "react-redux";

const DosaChutneyContact = () => {
    const company = useSelector((state) => state.companyData.company)
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    const [fullName, setFullName] = useState("")
    const [email, setEmail] = useState("")
    const [message, setMessage] = useState("")
    const [phoneNumber, setPhoneNumber] = useState("")
    const [errors, setErrors] = useState({
        fullName: "",
        email: "",
        message: "",
        phoneNumber: "",
    })
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const images = [
        { "src": "https://plus.unsplash.com/premium_photo-1665669263531-cdcbe18e7fe4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8YmFrZXJ5fGVufDB8fDB8fHww" },
        { "src": "https://plus.unsplash.com/premium_photo-1675788938970-e2716f23b1f9?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NXx8YmFrZXJ5fGVufDB8fDB8fHww" },
        { "src": "https://images.unsplash.com/photo-1534432182912-63863115e106?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTF8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1563729784474-d77dbb933a9e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzJ8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1618427012166-b0e03d490a4a?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NDB8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1519915028121-7d3463d20b13?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8NzR8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1609590981063-d495e2914ce4?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8ODF8fGJha2VyeXxlbnwwfHwwfHx8MA%3D%3D" },
        { "src": "https://images.unsplash.com/photo-1580959422798-c487f21d1a08?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTcwfHxiYWtlcnl8ZW58MHx8MHx8fDA%3D" },
        { "src": "https://images.unsplash.com/photo-1629320119721-5a2aa9ce9dbf?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjAzfHxiYWtlcnl8ZW58MHx8MHx8fDA%3D" },
        { "src": "https://images.unsplash.com/photo-1619286311276-d8343d00ce1f?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjQ2fHxiYWtlcnl8ZW58MHx8MHx8fDA%3D" },
    ]
    // useEffect(() => {
    //     const container = containerRef.current;
    //     const content = contentRef.current;

    //     if (!container || !content) return;

    //     let scrollLeft = 0;
    //     let animationFrame;

    //     const clone = content.cloneNode(true);
    //     container.appendChild(clone);

    //     const animate = () => {
    //         scrollLeft += 0.5;
    //         if (scrollLeft >= content.scrollWidth) {
    //             scrollLeft = 0;// Reset seamlessly
    //         }
    //         container.scrollLeft = scrollLeft;
    //         animationFrame = requestAnimationFrame(animate);
    //     };

    //     animationFrame = requestAnimationFrame(animate);

    //     return () => cancelAnimationFrame(animationFrame);
    // }, []);
    const getImagesCarousel = (data) => {
        return (
            <div className="DosaChutneyContact-ImageCarousel" ref={containerRef}>
                <div className="DosaChutneyContact-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        <img key={index} src={data?.src} alt={`img-${index}`} className="DosaChutneyContact-Cont-image" />

                    ))}
                </div>
            </div>
        )
    }
    const handleChange = (name) => {
        setErrors({
            ...errors,
            [name]: "",
        });
    };
    const validateEmail = () => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    };
    const validateForm = () => {
        let valid = true;
        const nameRegex = /^[A-Za-z]+([ '-][A-Za-z]+)*$/;
        let newErrors = {
            fullName: "",
            email: "",
            message: "",
            phoneNumber: "",
        }
        const trimmedName = fullName.trim();
        const trimmedEmail = email.trim();
        const trimmedPhone = phoneNumber.trim();
        if (trimmedName === "") {
            newErrors.fullName = "*Required";
            valid = false;
        } else if (trimmedName.length < 2 || !nameRegex.test(trimmedName)) {
            newErrors.fullName = "Please enter a valid name";
            valid = false;
        }


        if (trimmedEmail === "") {
            newErrors.email = "*Required";
            valid = false;
        } else if (!validateEmail(trimmedEmail)) {
            newErrors.email = "*Invalid email format";
            valid = false;
        }


        if (trimmedPhone === "") {
            newErrors.phoneNumber = "*Required";
            valid = false;
        }

        if (message.trim() === "") {
            newErrors.message = "*Required";
            valid = false;
        }
        setErrors(newErrors);
        return valid;
    };
    const handleContact = async () => {
        const data = {
            "WebsiteID": company?.ID || "",
            "Name": fullName,
            "Email": email,
            "PhoneNo": phoneNumber,
            "Message": message,
            "Subject": "",
            "OrderID": "",
        }
        if (validateForm() && !loading) {
            setLoading(true)
            let res = await contactEnquiry(data)
            if (res) {
                setEmail("")
                setFullName("")
                setMessage("")
                setPhoneNumber("")
                setLoading(false)
                setShowSuccess(true)
                setTimeout(() => {
                    document.querySelector('.succes-alert').classList.add('fade-out');
                    setTimeout(() => {
                        setShowSuccess(false)
                    }, 1000);
                }, 2000);
            } else {
                setLoading(false)
            }
        }
    }
    const getForm = () => {
        return (
            <div className="DosaChutneyContact-Form">
                <InputComponent
                    label={"Name"}
                    placeholder={""}
                    value={fullName}
                    onChange={(e) => {
                        setFullName(e.target.value)
                        handleChange("fullName")
                    }}
                    error={errors.fullName !== ""}
                    errorText={errors.fullName}
                    required />
                <InputComponent
                    label={"Email"}
                    placeholder={""}
                    onChange={(e) => {
                        setEmail(e.target.value)
                        handleChange("email")

                    }}
                    value={email}
                    error={errors.email !== ""}
                    errorText={errors.email}
                    required />
                <InputComponent
                    label={"Phone"}
                    placeholder={""}
                    onChange={(e) => {
                        setPhoneNumber(e.target.value)
                        handleChange("phoneNumber")

                    }}
                    value={phoneNumber}
                    error={errors.phoneNumber !== ""}
                    errorText={errors.phoneNumber}
                    type="number"
                    required />

                <TextAreaComponent
                    label={"Message"}
                    placeholder={""}
                    onChange={(e) => {
                        setMessage(e.target.value)
                        handleChange("message")

                    }}
                    value={message}
                    error={errors.message !== ""}
                    errorText={errors.message}
                    required />
                {showSuccess && < div className="succes-alert">
                    ✔ Thanks for contacting us! We’ve received your message and will be in touch soon.
                </div>}
                <div className="DosaChutneyContact-Form-button"
                    onClick={() => {
                        handleContact()
                    }}>
                    {loading && <div className="DosaChutneyContact-Form-button-loader-btn" />}  Send Message
                </div>
            </div>)
    }
    return (
        <div className="DosaChutneyContact">
            <div className="DosaChutneyContact-Hero"
                style={{
                    backgroundImage: `linear-gradient(135deg, rgba(32, 70, 7, 0.59), rgba(19, 44, 2, 0.7)), url(${heroBackground})`
                }}>
                <div className="DosaChutneyContact-Hero-header">
                    Contact Us
                </div>
                <div className="DosaChutneyContact-Hero-subheader">
                    We'd love to hear from you
                </div>
            </div>
            <div className="DosaChutneyContact-Container">
                <div className="DosaChutneyContact-Container-header">
                    <div className="DosaChutneyContact-Container-header-subtext">
                        Contact Us
                    </div>
                    <div className="DosaChutneyContact-Container-header-text">
                        Get In Touch
                    </div>
                    <img alt="" src={border}
                        className="DosaChutneyContact-Container-header-border" />
                    <div className="DosaChutneyContact-Container-header-content">
                        Have questions or feedback? We'd love to hear from you
                    </div>
                    {getForm()}
                </div>
            </div>
            {getImagesCarousel(images)}
        </div>
    )
}
export default DosaChutneyContact